"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCssValue = void 0;
var _sharedThemeSettings = require("../themes/sharedThemeSettings");
var _Theme = require("../themes/Theme");
var _defaultUnits = _interopRequireDefault(require("../utils/vars/defaultUnits"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var PROPS_WITH_COLOR = ["background", "backgroundColor", "color", "border", "borderColor"];
var PROPS_WITH_SIZE = ["size", "iconSize"];
var themeSizes = ["small", "medium", "large"];
var transformIndividualValue = function transformIndividualValue(value, options) {
  if (options.canHaveColor && _Theme.themeColors.includes(value)) {
    return "var(--theme-colors-".concat(value, ")");
  }
  if (options.canHaveSize && themeSizes.includes(value)) {
    return _sharedThemeSettings.iconSizes[value] + options.defaultUnit;
  }
  if (value.startsWith("$")) {
    var token = value.replace("$", "");
    if (_Theme.themeColors.includes(token)) {
      return "var(--theme-colors-".concat(token, ")");
    }
    if (themeSizes.includes(token)) {
      return _sharedThemeSettings.iconSizes[token] + options.defaultUnit;
    }
    var number = Number(token);
    if (!isNaN(number)) {
      return String(number * _sharedThemeSettings.spacing.base) + options.defaultUnit;
    }
  }
  if (!options.defaultUnit) {
    return value;
  }
  return Number(value) ? value + options.defaultUnit : value;
};
var getOptions = function getOptions(options) {
  var _ref, _normalized$defaultUn, _normalized$canHaveCo, _normalized$canHaveSi;
  var normalized = typeof options === "string" ? {
    key: options
  } : options;
  return {
    defaultUnit: (_ref = (_normalized$defaultUn = normalized.defaultUnit) !== null && _normalized$defaultUn !== void 0 ? _normalized$defaultUn : _defaultUnits.default[normalized.key]) !== null && _ref !== void 0 ? _ref : "",
    canHaveColor: (_normalized$canHaveCo = normalized.canHaveColor) !== null && _normalized$canHaveCo !== void 0 ? _normalized$canHaveCo : PROPS_WITH_COLOR.includes(normalized.key),
    canHaveSize: (_normalized$canHaveSi = normalized.canHaveSize) !== null && _normalized$canHaveSi !== void 0 ? _normalized$canHaveSi : PROPS_WITH_SIZE.includes(normalized.key)
  };
};

/**
 * Transforms raw value to a valid CSS value based on property name
 *   - adds units to numeric values
 *   - transforms colors to theme values
 *   - handles shorthand properties
 *
 * More details on shorthand properties:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
 */
var parseCssValue = exports.parseCssValue = function parseCssValue(value, options) {
  var parsedOptions = getOptions(options);
  if (typeof value === "number" && !isNaN(value)) {
    return String(value) + (value ? parsedOptions.defaultUnit : "");
  }
  if (typeof value !== "string") {
    return undefined;
  }
  if (!value.includes(" ") && !value.includes("(")) {
    if (!value.startsWith("-")) {
      return transformIndividualValue(value, parsedOptions);
    }
    return "-" + transformIndividualValue(value.slice(1), parsedOptions);
  }
  return value.split(" ").filter(function (v) {
    return v;
  }).map(function (v) {
    return v.split("(").map(function (v) {
      return v.split(")").map(function (v) {
        return v.split("-").map(function (v) {
          return transformIndividualValue(v, parsedOptions);
        }).join("-");
      }).join(")");
    }).join("(");
  }).join(" ");
};